import { VNode } from 'vue';
import Customer from '@/customer/models/Customer';
import CustomerProp, { PropType } from '@/customer/models/CustomerProp';
import Avatar from './Avatar.vue';
import Score from './Score.vue';
import Group from './Group.vue';
import Chat from './Chat.vue';
import Custom from './Custom.vue';
import SubscribeAt from './SubscribeAt.vue';
import moment from 'moment';

export interface CustomerDisplayColumn {
  title: string;
  key: string;
  sortable: boolean;
  fixed: string;
  width?: number;
  render: (h: any, params: any) => VNode;
}

export default (
  that: any,
  field: CustomerProp,
  width: number,
  widthFixed: boolean): CustomerDisplayColumn => {

  function decorateIfSpecialType(prop: any, str: any): string {
    if (prop.propType === PropType.Enum) {
      Object.keys(prop.enumValue).forEach((k: string) => {
        if (prop.enumValue[k] === str) {
          return k;
        }
      });
    } else if (prop.propType === PropType.DateTime && str && str.length > 0 && str !== '-') {
      moment.locale('zh-cn');
      return moment(str, 'YYYY-MM-DD HH:mm:ss').fromNow();
    } else {
      return str;
    }
  }

  function displayContent(prop: any, customer: Customer): string {
    const fds = prop.fieldName.split('.');
    if (fds.length > 1) {
      let v: any = customer;
      fds.forEach((ele: any) => {
        if (!v) {
          return '-';
        } else {
          v = v[ele];
        }
      });
      return decorateIfSpecialType(prop, v) || '-';
    } else {
      let str = (customer as any)[prop.fieldName] ? (customer as any)[prop.fieldName] : (customer as any)['privateProps'][prop.fieldName];
      str = str ? str : '-';
      return decorateIfSpecialType(prop, str);
    }
  }

  const renders: any = {
    'wxProps.nickname': (h: any, params: any): VNode => {
      return h(Avatar, {
        props: {
          customer: new Customer(params.row),
        },
        on: {
          showDetail: (customer: Customer) => {
            that.$store.commit('SHOW_CUSTOMER_DETAIL', customer);
          },
        },
      });
    },
    'wxProps.subscribeTime': (h: any, params: any): VNode => {
      return h(SubscribeAt, {
        props: {
          customer: new Customer(params.row),
        },
      });
    },
    'memberInfo.score': (h: any, params: any): VNode => {
      return h(Score, {
        props: {
          customer: new Customer(params.row),
        },
        on: {
          showScoreDetail: (customer: Customer) => {
            that.$store.commit('SHOW_CUSTOMER_SCORE_DETAIL', customer);
          },
        },
      });
    },
    'chat':  (h: any, params: any): VNode => {
      return h(Chat, {
        props: {
          customer: new Customer(params.row),
        },
      });
    },
    'groups': (h: any, params: any): VNode => {
      return h(Group, {
        props: {
          customer: new Customer(params.row),
        },
      });
    },
  };
  let render: (h: any, params: any) => VNode ;
  if (renders.hasOwnProperty(field.fieldName)) {
    const fieldName: any = field.fieldName;
    render = renders[fieldName];
  } else {
    render = (h: any, params: any): VNode => {
      // return h(Custom, {
      //   props: {
      //     customer: new Customer(params.row),
      //     prop: field,
      //   },
      // });
      return h('div', displayContent(field, new Customer(params.row)));
    };
  }
  const sortablePropTypes = [
    PropType.Numeric,
    PropType.DateTime,
    PropType.LocalDate,
  ];
  let fixedValue = '';
  if (field.fieldName === 'chat') {
    fixedValue = widthFixed ? 'right' : 'none';
  } else if (field.fieldName === 'wxProps.nickname') {
    fixedValue = widthFixed ? 'none' : 'none';
  } else {
    fixedValue = 'none';
  }
  return {
    title: (field.propName as string),
    key: (field.fieldName as string),
    sortable: !sortablePropTypes.includes(field.propType) || field.fieldName === 'groups' ? false : true,
    fixed: fixedValue,
    width,
    render,
  };
};
